module.exports = __webpack_public_path__ + "static/media/sudoGPRone.c600e75f.jpg";